/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pie': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 4C9.4 4 4 9.4 4 16s5.4 12 12 12 12-5.4 12-12S22.6 4 16 4zm9.9 11H17V6.1c4.7.4 8.5 4.2 8.9 8.9zM16 26c-5.5 0-10-4.5-10-10 0-5.2 4-9.4 9-9.9V17h10.9c-.5 5-4.7 9-9.9 9z" id="Layer_1"/>'
  }
})
